import {Course, SchoolClass, SchoolClassCourse} from "models"
import {Image, Pressable} from "react-native"
import {memo, PropTypes, propTypesExact, shapeComponent, ShapeComponent, Text, useI18n, View} from "shared/base"
import AppHistory from "shared/history"
import Icon from "@kaspernj/api-maker/build/utils/icon"
import Link from "@kaspernj/api-maker/build/link"
import Logger from "@kaspernj/api-maker/build/logger"
import React from "react"
import Routes from "shared/routes"

export default memo(shapeComponent(class RoutesUserSchoolClassesClassSpaceCourseCardSmall extends ShapeComponent {
  static defaultProps = {
    onPressCourse: null,
    to: null,
    schoolClassCourse: null
  }

  static propTypes = propTypesExact({
    course: PropTypes.instanceOf(Course).isRequired,
    onPressCourse: PropTypes.func,
    schoolClass: PropTypes.instanceOf(SchoolClass).isRequired,
    schoolClassCourse: PropTypes.instanceOf(SchoolClassCourse),
    to: PropTypes.string
  })

  setup() {
    const {t} = useI18n({namespace: "js.routes.user.school_classes.class_space.continue_working_on"})

    this.logger ||= new Logger({name: "RoutesUserSchoolClassesClassSpaceCourseCardSmall"})
    this.logger.setDebug(false)
    this.setInstance({t})
  }

  render() {
    const {course, schoolClass, schoolClassCourse} = this.p
    const courseGroup = course.courseGroups().loaded()[0]
    let computedTo

    if (schoolClassCourse) {
      computedTo = Routes.userCoursePath(course.id(), {school_class_course_id: schoolClassCourse.id()})
    } else {
      computedTo = Routes.userCoursePath(course.id(), {school_class_id: schoolClass.id()})
    }

    const to = this.p.to || computedTo

    this.course = course
    this.to = to

    const content = (
      <>
        <Image source={course.backgroundImageUrl()} style={this.courseBackgroundImageStyle ||= {width: 290, height: 180, marginBottom: 12, borderRadius: 40}} />
        <Text style={this.courseNameStyle ||= {color: "#2c2c96", fontSize: 28, fontWeight: 700}}>
          {course.name()}
        </Text>
        <View style={this.textViewStyle ||= {flexDirection: "row", alignItems: "center"}}>
          {courseGroup &&
            <View style={this.iconAndNameContainerStyle ||= {flexDirection: "row", alignItems: "center"}}>
              <Icon color="#87a2d5" name={courseGroup.icon() || "pencil"} size={18} />
              <Text style={this.courseGroupNameStyle ||= {marginLeft: 12, color: "#87a2d5", fontFamily: "HankenGrotesk", fontSize: 20, fontWeight: 700}}>
                {courseGroup.name()}
              </Text>
            </View>
          }
          {course.hasEstimatedTime() &&
            <>
              <Text style={this.dashStyle ||= {marginLeft: 12, marginRight: 12, color: "#87a2d5", fontFamily: "HankenGrotesk", fontSize: 24, fontWeight: 400}}>
                -
              </Text>
              <Text style={this.estimatedTimeTextStyle ||= {color: "#87A2D5", fontFamily: "HankenGrotesk", fontSize: 20, fontWeight: 400}}>
                {course.estimatedTime()}
              </Text>
            </>
          }
        </View>
      </>
    )

    if (!this.p.onPressCourse) {
      return (
        <Link dataSet={this.cache("courseCardLinkDataSet", {class: "class-space-course-card-link", courseId: course.id()}, [course.id()])} to={to}>
          {content}
        </Link>
      )
    }

    return (
      <Pressable
        dataSet={this.cache("courseCardPressableDataSet", {class: "class-space-course-card-link", courseId: course.id()}, [course.id()])}
        onPress={this.tt.onCoursePress}
      >
        {content}
      </Pressable>
    )
  }

  onCoursePress = async () => {
    const {onPressCourse} = this.p
    const {course, to} = this

    this.logger.debug(() => ["[class-space brain-break] course-card:onCoursePress", {
      courseId: course.id(),
      hasOnPressCourse: Boolean(onPressCourse),
      to
    }])

    if (onPressCourse) {
      const shouldContinue = await onPressCourse({course, to})

      this.logger.debug(() => ["[class-space brain-break] course-card:onCoursePress:onPressCourse-result", {
        courseId: course.id(),
        shouldContinue,
        to
      }])

      if (shouldContinue === false) {
        return
      }
    }

    this.logger.debug(() => ["[class-space brain-break] course-card:onCoursePress:navigate", {
      courseId: course.id(),
      to
    }])

    AppHistory.push(to)
  }
}))
